import { render } from "./DayReport.vue?vue&type=template&id=1c9dbec0"
import script from "./DayReport.vue?vue&type=script&lang=ts"
export * from "./DayReport.vue?vue&type=script&lang=ts"
script.render = render

export default script